/**
 * Brand-namespaced localStorage.
 *
 * White-label builds can share a browser origin (e.g. several clients served
 * from localhost during dev, or two builds on the same host). Plain
 * localStorage keys are global to the origin, so one client's auth / role /
 * endpoint state would leak into another's. Prefixing every key with the
 * Firebase projectId — the real per-client boundary — keeps each build's state
 * isolated.
 */
import brand from "@/config/brand";

const NS = "wf:" + ((brand.firebase && brand.firebase.projectId) || "default") + ":";

export function nsKey(key) {
  return NS + key;
}

export const ls = {
  get(key) {
    try { return localStorage.getItem(nsKey(key)); } catch (e) { return null; }
  },
  set(key, value) {
    try { localStorage.setItem(nsKey(key), value); } catch (e) { /* no-op (private mode / quota) */ }
  },
  remove(key) {
    try { localStorage.removeItem(nsKey(key)); } catch (e) { /* no-op */ }
  }
};
